import {
    LOAD_LOTTERY_INFO,
    SET_LOTTERY_CODE,
    SET_LOTTERY_ROUND_CODE,
    LOAD_LOTTERY_RATE_CONDITION,
    SET_LOTTERY_TYPE,
    SET_LOTTERY_SET_NUMBER_DATA,
    SET_LOTTERY_SET_NUMBER_DETAIL_DATA
} from './../../actions/lottery/info';

const initialState = {
    result: [],
    code: null,
    type: null,
    rateAndCondition: null,
    ticketSet: null,
    ticketSetNumber: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_LOTTERY_INFO:
            return { ...state, result: action.payload.items };
        case SET_LOTTERY_CODE:
            return { ...state, code: action.payload.items };
        case SET_LOTTERY_ROUND_CODE:
            return { ...state, roundCode: action.payload.items };
        case LOAD_LOTTERY_RATE_CONDITION:
            return { ...state, rateAndCondition: action.payload.items };
        case SET_LOTTERY_SET_NUMBER_DATA:
            return { ...state, ticketSet: action.payload.items };
        case SET_LOTTERY_SET_NUMBER_DETAIL_DATA:
            return { ...state, ticketSetNumber: action.payload.items };
        case SET_LOTTERY_TYPE:
            return { ...state, type: action.payload.items };
        default:
            return state;
    }
}